import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';
import { isNumberGreaterThanZero } from '@thesavingsgroup/utils/isNumberGreaterThanZero';
import i18n from 'i18next';
import isEmpty from 'lodash/isEmpty';
import toNumber from 'lodash/toNumber';
import { StateCreator } from 'zustand';

import { PreviewState } from './types/PreviewState';
import { PreviewStateDependencies } from './types/PreviewStateDependencies';
import { SetPreviewActivationStateParams } from './types/SetPreviewActivationStateParams';

export const keysToPersist = [
  'firstName',
  'lastName',
  'primaryEmailAddress',
  'primaryPhoneNumber',
];

export const previewStore =
  ({
    useLeadChannelStore,
    useParameterStore,
  }: PreviewStateDependencies): StateCreator<PreviewState> =>
  (set) => ({
    firstName: '',
    lastName: '',
    primaryEmailAddress: '',
    primaryPhoneNumber: '',

    computed: {
      get hasValidPreviewOffer(): boolean {
        const { amount, apr, payment, term } = useParameterStore.getState();

        return [
          toNumber(amount),
          toNumber(apr),
          toNumber(payment),
          toNumber(term),
        ].every(isNumberGreaterThanZero);
      },
      get titleText(): string {
        const { applicationType } = useParameterStore.getState();
        const {
          computed: { brand, displayLabel },
        } = useLeadChannelStore.getState();

        const isDefaultTitle =
          !isInEnum(applicationType, ApplicationType) ||
          isEmpty(brand) ||
          isEmpty(displayLabel);

        return isDefaultTitle
          ? i18n.t('PreviewOfferPage.title.default')
          : i18n.t(`PreviewOfferPage.title.${applicationType}`, {
              brand,
              displayLabel,
            });
      },
    },

    setPreviewActivationState: (
      params: SetPreviewActivationStateParams,
    ): void => {
      const {
        firstNameValue,
        lastNameValue,
        primaryEmailAddressValue,
        primaryPhoneNumberValue,
      } = params;

      set({
        firstName: firstNameValue,
        lastName: lastNameValue,
        primaryEmailAddress: primaryEmailAddressValue,
        primaryPhoneNumber: primaryPhoneNumberValue,
      });
    },
  });
